import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Table from '../../../../../../components/table/Table';


export default class HighRisk extends Component {
    render() {
        if (this.props.details.length > 0) {
            return (
                <Row>
                    <Col md="12">
                        <Table responsive className="table--bordered hpi" style={this.props.style}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>High Risk Type</th>
                                    <th>Date of Interest</th>
                                    <th>Extra Info.</th>
                                    <th>Transaction Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.details.map((item, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{item.high_type_risk}</td>
                                        <td>{item.date_of_interest}</td>
                                        <td>{item.extra_info}</td>
                                        <td>{item.date_of_transaction}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about this bike being high risk</p></Col></Row>);
    }
}

HighRisk.propTypes = {
    details: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/highRisk.js